import { Box, Tab, Tabs, Typography } from '@mui/material';
import { Link, Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { MDBox } from '../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';

interface TabConfig {
    label: string;
    route: string;
    Component?: any;
}

interface EmpowermentFinancingDataPageProps {
    pageTitle?: string;
    elementName?: string;
    tabs?: TabConfig[];
}

export const EmpowermentFinancingDataPage = ({ pageTitle = 'Data Page', elementName, tabs }: EmpowermentFinancingDataPageProps) => {
    const { url: basePath } = useRouteMatch();
    const hasTabs = !!tabs && tabs.length > 0;
    const tabRoutes = hasTabs ? tabs!.map(tab => `${basePath}/${tab.route}`) : [];

    const routeMatch = useRouteMatch(tabRoutes);
    const currentTab = routeMatch?.path;

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', minHeight: '600px' }}>
            <MDBox style={{ padding: '10px' }}>
                <MDTypography variant="h4" fontWeight="bold" style={{ paddingBottom: '15px' }}>
                    {pageTitle}{elementName ? ` - ${elementName}` : ''}
                </MDTypography>
            </MDBox>
            {hasTabs ? (
                <>
                    <Tabs value={currentTab} sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '#fafafa' }}>
                        {tabs!.map((tab, index) => (
                            <Tab key={index} label={tab.label} value={tabRoutes[index]} to={tabRoutes[index]} component={Link} />
                        ))}
                    </Tabs>
                    <MDBox style={{ padding: '10px' }}>
                        <Switch>
                            {tabs!.map((tab, index) => (
                                <Route key={index} path={tabRoutes[index]}>
                                    {tab.Component ? <tab.Component /> : <Typography variant="body1">Coming soon.</Typography>}
                                </Route>
                            ))}
                            <Redirect to={tabRoutes[0]} />
                        </Switch>
                    </MDBox>
                </>
            ) : (
                <MDBox style={{ padding: '10px' }}>
                    <Typography variant="body1">Coming soon.</Typography>
                </MDBox>
            )}
        </Box>
    );
};
